import { useEffect, useState } from "react";
import Image from "next/image";
import Text from "ab-text";
import Link from "ab-link";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import "./cierre-hotel.scss";

const CierreHotel = ({ t, i18n }) => {
  const [showPopup, setShowPopup] = useState(true);
  // const [defaultLang, setDefaultCookieLang] = useState("ES");
  const router = useRouter();

  useEffect(() => {
    let tempHotelClosed = sessionStorage.getItem("cierre-hotel");
    // let tempHotelClosed = Cookies.get("cookie-policy");
    // console.log(`tempHotelClosed |${tempHotelClosed}|`);
    if (tempHotelClosed) {
      setShowPopup(false);
    } else {
      setShowPopup(true);
    }
  }, []);

  /// validar visualizacion por path

  // useEffect(() => {
  //   console.log(`pathname |${router?.pathname}|`);
  //   if(router?.pathname.includes === "/hotel"){
  //     setShowPopup(false);
  //   }
  // }, [router?.pathname]);

  const closeModal = () => {
    sessionStorage.setItem("cierre-hotel", "closed");
    Cookies.set("cierre-hotel", "closed");
    setShowPopup(false);
    document.body.style.overflow = "initial";
  };
  return (
    <div
      className={`popup-cierre-modal ${showPopup ? "show" : ""}`}
      id={"modal-container"}
      onClick={(e) => closeModal()}
      role="button"
      tabIndex="0"
    >
      <div
        className={"popup-cierre-content"}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <button className="popup-cierre-close" onClick={(e) => closeModal()}>
          +
        </button>

        <div className={"popup-cierre-form"}>
          <div className="popup-cierre-image-container">
            <Image
              src={"/images/popup-cierre-hotel.png"}
              alt={"hotel"}
              width={120}
              height={120}
            />
          </div>

          <Text element="h3" className={"cierre-title gold"}>
            {t("preparing")}
          </Text>
          <Text element="p">{t("cierreHotel")}</Text>
        </div>
      </div>
    </div>
  );
};

export default CierreHotel;
